window.Vue = require('vue');
var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo)

// You can also pass in the default options
Vue.use(VueScrollTo, {
    container: "#scroll-to-top-section",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

Vue.component('acl-my-account-component', require('./pages/users/MyAccount').default);
Vue.component('users-list-component', require('./pages/users/List').default);
Vue.component('permissions-list-component', require('./pages/permissions/List').default);
Vue.component('roles-list-component', require('./pages/roles/List').default);
//
